/**
 * 添加编辑
 * 2018-1-24
 */
"use strict";
angular.module("mapSchedulingAddEditModule", [
    "addEditServiceMoudle", //服务
]).
controller("mapSchedulingAddEditCtrl", ['$scope', "trsHttpService", "$q", 'paramsObj', "$timeout", "addEditService", "$state", '$element', '$modalInstance', 'modalDialog',
    function($scope, trsHttpService, $q, paramsObj, $timeout, addEditService, $state, $element, $modalInstance, modalDialog) {
        initStatus();
        initData();
        /**
         * [initData description:初始化数据]            
         */
        function initData() {
            if ($scope.status.mapId !== "" && $scope.status.mapId !== undefined) {
                $scope.params = {
                    "typeid": 'screen',
                    "serviceid": 'mapSchedulingMgr',
                    "modelid": 'search',
                    "page_size": $scope.status.page.PAGESIZE,
                    "page_no": $scope.status.page.copyCurrPage - 1,
                    "id": $scope.status.mapId,
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), $scope.params, "post").then(function(data) {
                    if (data.MAPRESULT.status == 'SUCCESS') {
                        $scope.mapListData = data.MAPRESULT.content.DETAILS;
                        $scope.data.fiexdPosition = filterFixedPosition(data.MAPRESULT.content.DETAILS);
                        $scope.status.newSeatBtn = false;
                        if ($scope.mapListData.length >= 100) {
                            $scope.status.newSeatBtn = true;
                        }
                        $scope.data.postionId = data.MAPRESULT.content.HEAD.CENTERPOS;
                        $scope.data.mapScale = data.MAPRESULT.content.HEAD.MAPSCALE;
                        mapcentertext();
                    } else {
                        return;
                    }
                });
            }
        };

        function filterFixedPosition(data) {
            var array = [];
            for (var i = 0; i < data.length; i++) {
                if (data[i].POSTYPE == 2) {
                    array.push(data[i]);
                }
            }
            return array;
        }

        /**
         * [initStatus description:初始化状态]
         */
        function initStatus() {
            $scope.status = {
                tempId: '',
                isSave: false,
                mapId: paramsObj.id,
                searchShow: false, //是否显示搜索框
                searchNameShow: true, //是否显示名称
                newSeatBtn: false, //新建位置是否禁用
                page: {
                    CURRPAGE: 1,
                    PAGESIZE: 100,
                    ITEMCOUNT: '',
                    PAGECOUNT: '',
                    copyCurrPage: 1,
                },
                errPrompt: false, //错误提示
                mapScale: [
                    "20米",
                    "50米",
                    "100米",
                    "200米",
                    "500米",
                    "1公里",
                    "2公里",
                    "5公里",
                    "10公里",
                    "20公里",
                    "25公里",
                    "50公里",
                    "100公里",
                    "200公里",
                    "500公里",
                    "1000公里",
                    "2000公里"
                ],
                keyword: '',
                titleVerification: true, //标题校验
            };
            $scope.data = {
                vtitle: paramsObj.title,
                postionId: '',
                mapScale: 4, //初始化比例
                promptMes: '',
                mapcentername: '',
                fiexdPosition: [],
            };
            closeBox();
        }
        /**
         * [closeBox description] 关闭弹框
         * @return {[type]} [description]
         */
        function closeBox() {
            var blurEvent = function(e) {
                if ($element.find(e.target).closest('.m-sle').length < 1) {
                    $scope.status.searchShow = false;
                    $scope.$apply();
                }
            };
            $("body").bind("click", blurEvent);
            $scope.$on("$destroy", function() {
                $("body").unbind("click", blurEvent);
            });
        }
        /**
         * [titleValidate description] 验证标题
         * @return {[type]} [description]
         */

        $scope.titleValidate = function() {
            $scope.params = {
                "typeid": 'screen',
                "serviceid": 'mapSchedulingMgr',
                "modelid": 'checkTitle',
                "title": $scope.data.vtitle,
                "id": $scope.status.mapId,
            };
            $scope.status.titleVerification = true;
            if ($scope.data.vtitle.length < 1) {
                return;
            }
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), $scope.params, "post").then(function(data) {
                $scope.status.tempId = data.MAPRESULT.content.ID;
                if (data.MAPRESULT.status == 'SUCCESS') {
                    $scope.status.titleVerification = false;
                    if (data.MAPRESULT.content != null) {
                        $scope.status.mapId = data.MAPRESULT.content.ID;
                    }
                } else {
                    modalDialog.alertType("", "标题重复，请重新输入!", "info", false);
                    return;
                }
            });
        };
        /**
         * [removeContent description] 清除位置搜索的内容
         * @return {[type]} [description]
         */
        $scope.removeContent = function() {
            $scope.status.keyword = '';
            $scope.status.searchNameShow = true;
            $timeout(function() {
                requestListData();
            });
        };
        /* 
         * [addSeat description] 添加位置
         * @return {[type]} [description]
         */
        $scope.addSeat = function(id) {
            if ($scope.status.titleVerification && paramsObj.id == undefined) {
                modalDialog.alertType("", "请填写正确的标题", "info", false);
                return;
            }
            addEditService.addSeat(id).then(function(data) {
                if (data == true) {
                    $timeout(function() {
                        requestListData();
                    }, 500);
                }
            });
        }
        /**
         * [editSeat description] 编辑位置
         * @param  {[type]} info [description]
         * @return {[type]}      [description]
         */
        $scope.editSeat = function(info) {
            addEditService.addSeat(info, true).then(function(data) {
                if (data == true) {
                    requestListData();
                }
            });
        }
        /* 
         * [deteleSeat description] 删除位置
         * * @return {[type]} [description]
         */
        $scope.deteleSeat = function(info) {
            modalDialog.confirmModal("", "确认要删除这条数据吗？", function() {
                $scope.params = {
                    "typeid": 'screen',
                    "serviceid": 'mapPostionMgr',
                    "modelid": 'delete',
                    "id": info.ID,
                    "mapcontrol_id": info.MAPCONTROLID
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), $scope.params, "post").then(function(data) {
                    if (data.MAPRESULT.status == 'SUCCESS') {
                        delrequestListData();
                    }
                });
            });
        }
        /* 
         * [delrequestListData description:获取数据]
         */
        function delrequestListData() {
            $scope.params = {
                "typeid": 'screen',
                "serviceid": 'mapSchedulingMgr',
                "modelid": 'search',
                "page_size": $scope.status.page.PAGESIZE,
                "page_no": $scope.status.page.copyCurrPage - 1,
                "id": $scope.status.mapId,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), $scope.params, "post").then(function(data) {
                if (data.MAPRESULT.status == 'SUCCESS') {
                    $scope.mapListData = data.MAPRESULT.content.DETAILS;
                    $scope.status.newSeatBtn = false;
                    if ($scope.mapListData.length == 0) {
                        $scope.data.postionId = '';
                        $scope.data.mapcentername = '';
                    } else {
                        for (var c = 0; c < $scope.mapListData.length; c++) {
                            if ($scope.mapListData[c].ID == data.MAPRESULT.content.HEAD.CENTERPOS) {
                                $scope.data.postionId = data.MAPRESULT.content.HEAD.CENTERPOS;
                            } else {
                                $scope.data.postionId = '';
                                $scope.data.mapcentername = '';
                            }
                        }
                        mapcentertext();
                    }
                } else {
                    return;
                }
            });
        }

        /* 
         * [requestData description:获取数据]
         */
        function requestListData() {
            $scope.params = {
                "typeid": 'screen',
                "serviceid": 'mapSchedulingMgr',
                "modelid": 'search',
                "page_size": $scope.status.page.PAGESIZE,
                "page_no": $scope.status.page.copyCurrPage - 1,
                "id": $scope.status.mapId,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), $scope.params, "get").then(function(data) {
                if (data.MAPRESULT.status == 'SUCCESS') {
                    $scope.mapListData = data.MAPRESULT.content.DETAILS;
                    $scope.status.newSeatBtn = false;
                    if ($scope.mapListData.length > 100) {
                        $scope.status.newSeatBtn = true;
                    }
                    var arr = [];
                    for (var i = 0; i < data.MAPRESULT.content.DETAILS.length; i++) {
                        if (data.MAPRESULT.content.DETAILS[i].POSTYPE === 2) {
                            arr.push(data.MAPRESULT.content.DETAILS[i]);
                        }
                    }
                    $scope.data.fiexdPosition = arr;
                    //$scope.data.postionId = data.MAPRESULT.content.HEAD.CENTERPOS;
                    mapcentertext();
                } else {
                    return;
                }
            });
        }
        /* 
         * [mapcenter description] 设置地图中心位置
         * * @return {[type]} [description]
         */
        $scope.mapcenter = function(id) {
            $scope.data.postionId = id;
            mapcentertext();
            $scope.status.searchShow = false;
        }
        /* 
         * [mapcentertext description] 拼地图中心文本
         * * @return {[type]} [description]
         */
        function mapcentertext() {
            for (var i = 0; i < $scope.mapListData.length; i++) {
                if ($scope.mapListData[i].ID == $scope.data.postionId) {
                    $scope.data.mapcentername = ($scope.mapListData[i].POSTYPE == 1 ? '人员位置' : '固定位置') + "：" + $scope.mapListData[i].NAME
                }
            }
        }

        /* 
         * [saveMapSeat description] 保存地图位置
         * @return {[type]} [description]
         */
        $scope.saveMapSeat = function() {
            //保存前验证title防止重复
            if ($scope.data.vtitle == '' || $scope.data.vtitle == undefined) {
                modalDialog.alertType("", "请填写地图名称!", "info", false);
                return;
            } else {
                $scope.params = {
                    "typeid": 'screen',
                    "serviceid": 'mapSchedulingMgr',
                    "modelid": 'checkTitle',
                    "title": $scope.data.vtitle,
                    "id": $scope.status.mapId,
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), $scope.params, "post").then(function(data) {
                    if (data.MAPRESULT.status == 'SUCCESS') {
                        $scope.status.titleVerification = false;
                        if ($scope.mapListData == undefined || $scope.mapListData.length == 0) {
                            modalDialog.alertType("", "请添加地图位置!", "info", false);
                            return;
                        } else if ($scope.data.postionId == null || $scope.data.postionId == '') {
                            modalDialog.alertType("", "请设置中心位置!", "info", false);
                            return;
                        } else {
                            savedate();
                        }
                    } else {
                        modalDialog.alertType("", "标题重复，请重新输入!", "info", false);
                        $scope.status.titleVerification = true;
                        return;
                    }
                });
            }

        };
        /* 
         * [savedate description] 保存前验证title
         * @return {[type]} [description]
         */
        function savedate() {
            $scope.params = {
                "typeid": 'screen',
                "serviceid": 'mapSchedulingMgr',
                "modelid": 'save',
                "title": $scope.data.vtitle,
                "id": $scope.status.mapId,
                "postion_id": $scope.data.postionId,
                "map_scale": $scope.data.mapScale,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), $scope.params, "post").then(function(data) {
                if (data.MAPRESULT.status == 'SUCCESS') {
                    $scope.status.isSave = true;
                    $modalInstance.dismiss();
                }
            });
        }

        /**
         * [switchBtn description:切换在大屏上显示状态]
         */
        $scope.switchBtn = function(group) {
            if (group.DISPLAY === 1) {
                group.DISPLAY = 0;
            } else {
                group.DISPLAY = 1;
            }
            updateDisplay(group);
        };
        /**
         * [updateDisplay description:更新显示按钮的状态]
         */
        function updateDisplay(group) {
            if (group.DISPLAY === 1) {
                var judge = true;
            } else {
                var judge = false;
            }
            http: //10.100.119.29:9109/screen/mapPostionMgr/display?id=8&isdisplay=true
                $scope.params = {
                    "typeid": 'screen',
                    "serviceid": 'mapPostionMgr',
                    "modelid": 'display',
                    "id": group.ID,
                    "isdisplay": judge,
                };
            trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), $scope.params, "post")
        }
        /* 
         * [choseCenterSeat description] 选择中心位置
         * * @return {[type]} [description]
         */
        $scope.choseCenterSeat = function(id) {
            if ($scope.mapListData == undefined || $scope.mapListData.length == 0) {
                modalDialog.alertType("", "请先添加地图位置!", "info", false);
                return;
            } else {
                $scope.status.searchShow = true;
                $scope.searchMapName();
            }
        }
        /**
         * [searchMapName description] 搜索时替换值
         * @param  {[type]} value [description]
         * @return {[type]}       [description]
         */
        $scope.searchMapName = function(value) {
            var params = {
                "typeid": 'screen',
                "serviceid": 'mapPostionMgr',
                "modelid": 'search',
                'name': value,
                'mapcontrol_id': $scope.status.mapId
            };
            trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function(res) {
                if (res.MAPRESULT.content.length > 0 && typeof(res.MAPRESULT.content) != 'string') {
                    var arr = [];
                    for (var i = 0; i < res.MAPRESULT.content.length; i++) {
                        if (res.MAPRESULT.content[i].POSTYPE === 2) {
                            arr.push(res.MAPRESULT.content[i]);
                        }
                    }
                    // $scope.mapListData = arr;
                    $scope.data.fiexdPosition = arr;

                } else {
                    // $scope.mapListData = [];
                    $scope.data.fiexdPosition = [];
                }
            });
        };
        // /* 
        //  * [searchMapName description] 失去光标显示下拉框
        //  * * @return {[type]} [description]
        //  */
        // $scope.searchMapNameBlur = function(id) {
        //     $scope.status.searchNameShow = true;
        // }
        /**
         * [searchSource description] 根据关键词搜索来源 
         * @param  {[type]} $viewValue [description] 输入诶容
         * @return {[type]}            [description]
         */
        // var promise;
        // $scope.searchSource = function($viewValue) {
        //     if (promise) {
        //         $timeout.cancel(promise);
        //         promise = null;
        //     }
        //     promise = $timeout(function() {
        //         if ($viewValue !== "" && !angular.isObject($viewValue)) {
        //             http: //10.100.119.29:9109/screen/mapPostionMgr/search?name=&mapcontrol_id=2
        //                 var params = {
        //                     "typeid": 'screen',
        //                     "serviceid": 'mapPostionMgr',
        //                     "modelid": 'search',
        //                     "name": $viewValue,
        //                     "mapcontrol_id": $scope.status.mapId,
        //                 };
        //             return trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "post").then(function(data) {
        //                 for (var i = 0; i < data.MAPRESULT.content.length; i++) {
        //                     var name = (data.MAPRESULT.content[i].POSTYPE == 1 ? '人员位置' : '固定位置') + "：" + data.MAPRESULT.content[i].NAME;
        //                     data.MAPRESULT.content[i].NAME = name;
        //                     data.MAPRESULT.content[i].NAME = (function(name) {
        //                         var nameArray = name.split("#");
        //                         return nameArray[nameArray.length - 1];
        //                     })(name);
        //                 }
        //                 return data.MAPRESULT.content;

        //             });
        //         }
        //     }, 500);
        //     return promise;
        // };
        $scope.$watch("status.keyword", function(newV, oldV) {
            if (angular.isObject(newV)) {
                $scope.mapcenter(newV.ID);
                $scope.status.searchNameShow = true;
            }
        });

        /**
         * [deleteTempData 删除临时数据]
         * @return {[type]} [description]
         */
        function deleteTempData() {
            var params = {
                "typeid": 'screen',
                "serviceid": 'mapSchedulingMgr',
                "modelid": 'delete',
                "id": $scope.status.tempId,
                "istemp": 1,
            };
            trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function(data) {
                console.log(data);
            });
        }

        $scope.$on('$destroy', function() {
            if (!paramsObj.id && !$scope.status.isSave) {
                deleteTempData();
            }
        });
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };
    }
]);